import formatDate from '../../../helpers/format-date';
import { BlacklistDataContentTypes } from './types';

import styles from '../transaction.module.css';

const UserInfoBlock = ({ children }: { children: React.JSX.Element }) => (
  <div className={styles.userInfoBlock}>{children}</div>
);

const UserInfoRow = ({ title, value }: { title: string; value: string }) => (
  <div className={styles.userInfoRow}>
    <div className={styles.userInfoRowTitle}>{title}</div>
    <div className={styles.userInfoRowValue}>{value}</div>
  </div>
);

export default function BlacklistDataContent({
  data,
}: BlacklistDataContentTypes) {
  return (
    <>
      <div className={styles.userInfoDate}>{`Added ${formatDate(
        data?.createdAt as string,
      )}`}</div>
      <UserInfoBlock>
        <>
          <UserInfoRow title="Full name" value={data?.fullName as string} />
          {data?.aliases && data?.aliases?.length > 0 && (
            <UserInfoRow title="Alias" value={data.aliases.join(', ')} />
          )}
          {data?.nameNonLatin && (
            <UserInfoRow
              title="Name in non-Latin script"
              value={data.nameNonLatin}
            />
          )}
          {data?.gender && <UserInfoRow title="Gender" value={data.gender} />}
          {data?.dateOfBirth && data?.dateOfBirth.length > 0 && (
            <UserInfoRow title="DoB" value={data.dateOfBirth.join(', ')} />
          )}
          {data?.address && data?.address.length > 0 && (
            <UserInfoRow title="Address" value={data.address.join(', ')} />
          )}
          {data?.nationality && (
            <UserInfoRow title="Nationality" value={data.nationality} />
          )}
          {data?.personalIdNumber && data?.personalIdNumber.length > 0 && (
            <UserInfoRow
              title="Personal ID no."
              value={data.personalIdNumber.join(', ')}
            />
          )}
        </>
      </UserInfoBlock>
      {(data?.countryName ||
        (data?.countryOfResidence && data?.countryOfResidence.length > 0) ||
        (data?.placeOfBirth && data?.placeOfBirth.length > 0) ||
        (data?.countryCodes && data?.countryCodes?.length > 0)) && (
        <UserInfoBlock>
          <>
            {data?.countryName && (
              <UserInfoRow title="Country name" value={data.countryName} />
            )}
            {data?.countryOfResidence &&
              data?.countryOfResidence.length > 0 && (
                <UserInfoRow
                  title="Country of residence"
                  value={data?.countryOfResidence.join(', ')}
                />
              )}
            {data?.placeOfBirth && data?.placeOfBirth.length > 0 && (
              <UserInfoRow
                title="Place of birth"
                value={data?.placeOfBirth.join(', ')}
              />
            )}
            {data?.countryCodes && data?.countryCodes?.length > 0 && (
              <UserInfoRow
                title="Country code"
                value={data?.countryCodes.join(', ')}
              />
            )}
          </>
        </UserInfoBlock>
      )}

      {(data?.pspName ||
        data?.pspAddress ||
        (data?.swift && data?.swift.length > 0) ||
        data?.bic) && (
        <UserInfoBlock>
          <>
            {data?.pspName && (
              <UserInfoRow title="PSP name" value={data.pspName} />
            )}
            {data?.pspAddress && (
              <UserInfoRow title="PSP address" value={data?.pspAddress} />
            )}
            {data?.swift && (
              <UserInfoRow title="SWIFT" value={data?.swift.join(', ')} />
            )}
            {data?.bic && <UserInfoRow title="BIC" value={data?.bic} />}
          </>
        </UserInfoBlock>
      )}

      <UserInfoBlock>
        <>
          {data?.reason && <UserInfoRow title="Reason" value={data.reason} />}
          {data?.additionalInfo && (
            <UserInfoRow
              title="Other information"
              value={data?.additionalInfo}
            />
          )}
        </>
      </UserInfoBlock>
    </>
  );
}
